import React, {useState} from 'react';
import '../../App.scss';
import {PACKAGING_TYPES, UNIT_TYPES, WAREHOUSES, resolveEnum} from '../../Constants';
import {Form , Button, Table, Modal} from 'react-bootstrap'
import { PlusSquare } from 'react-bootstrap-icons';
import AuthorizedPage from '../../component/AuthorizedPage';
import ShipmentApi from '../../api/ShipmentApi';
import AccountingApi from '../../api/AccountingApi';
import { updateState } from '../StateHelper';
import RoleManagement from '../admin/RoleManagement';
import { Role } from '../../domain/Role';

const initialState = {
  accountingSummary: {totalOrderCount:0, totalAmountOfOrders: 0.0, totalAmountOfOrderPayments:0.0, totalAmountOfProductRefunds: 0.0, remainingAmountToPurchase: 0.0},
  accountingTransactions: new Array(),
  filteredAccountingTransactions: new Array(),
  selectedOrderId: null,
  showPayForOrderModal: false
};

const payTypes = [
  {key:"CASH", value:"Nakit"},
  {key:"BANK_TRANSFER", value:"Banka Transferi"},
  {key:"REFUND", value:"İade"}
];

const reasons = [
  {key:"ORDER_PAYMENT", value:"Sipariş Ödemesi"},
  {key:"PRODUCT_REFUND", value:"Ürün İadesi Olarak Ödeme"}
];

class BuyerFinanceManagement extends React.Component<any,any> {

  constructor(props: any) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = initialState;
  }

  componentDidMount() {
    this.init();
  }

  init() {
  this.loadAccountingSummary();
   this.loadAccountingTransactions();
  }

  refresh() {
   this.setState(initialState);
   this.init();
  }

 async loadAccountingTransactions() {
  let buyerIdParam = new URL(window.location.href).searchParams.get("buyerId");
    let response = await AccountingApi.listAccountingTransactions(new Number(buyerIdParam));
    if(response.success) {
      updateState(this, "accountingTransactions", response.data);
      updateState(this, "filteredAccountingTransactions", response.data);
    }
 }

 async loadAccountingSummary() {
  let buyerIdParam = new URL(window.location.href).searchParams.get("buyerId");
  let response = await AccountingApi.listAccountingSummary(new Number(buyerIdParam));
  if(response.success) {
    updateState(this, "accountingSummary", response.data);
  }
}

async onCheckContents(orderShipmentId: Number) {
  window.location.assign("/sevkiyat-siparis-yonetimi?orderShipmentId="+orderShipmentId);
}

async onShipmentLoading(orderShipmentId: Number) {
  await ShipmentApi.markAsLoading(orderShipmentId);
  this.refresh();
}

async onShipmentCompleted(orderShipmentId: Number) {
  await ShipmentApi.markAsCompleted(orderShipmentId);
  this.refresh();
}

  async onSubmit(e:any) {
      e.preventDefault();
      const formData = new FormData(e.target);
      const formObject = Object.fromEntries(formData);
      const json = JSON.stringify(formObject);  
      let response = await AccountingApi.payForOrder(this.state.selectedOrderId, formObject);
      if(response.success) {
        e.target.reset();
      }
      this.refresh();
  }

  onModalClose() {
    updateState(this, "showPayForOrderModal", false);
  }

  onColumnAction = (actionType: any, orderId:any) => {
    if("PAY_FOR_ORDER" == actionType) {
      updateState(this, "selectedOrderId", orderId);
      updateState(this, "showPayForOrderModal", true);
    }
  }

  renderAccountingTransactions = () => {
      return <Table  striped bordered hover>
              <thead>
                <tr>
                  <th>Müşteri Id</th>
                  <th>Tarih</th>
                  <th>İlgili Sipariş No</th>
                  <th>İşlem Türü</th>
                  <th>Ödeme Tipi</th>
                  <th>Logo Fatura No</th>
                  <th>Tutar</th>
                  <th>İşlem Yap</th>
                </tr>
              </thead>
              <tbody>
                {this.renderTransactionRows(this.state.filteredAccountingTransactions)}
              </tbody>
            </Table>;
  };

  renderTransactionRows = (transactions:any) => {
    return transactions && transactions.map((it:any) => {
      return <tr key={it.id + it.createdAt}>
              <td>{it.buyerId}</td>
              <td>{it.createdAt}</td>
              <td>{it.relatedOrderNumber}</td>
              <td>{it.reasonDetail && it.reasonDetail.label}</td>
              <td>{it.payTypeDetail && it.payTypeDetail.label}</td>
              <td>{it.logoInvoiceId}</td>
              <td style={{textAlign:"right"}}>{it.amount} &#8378;</td>
              <td><Button disabled={it.reasonDetail && it.reasonDetail.name != "NEW_ORDER"} variant="outline-success" onClick={() => this.onColumnAction("PAY_FOR_ORDER", it.id)}>Ödeme Yap</Button></td>
        </tr>
    });
  };

  renderDropdownOptions = (items:any) => {
    return items.map((it:any) => {
      return <option value={it.key}>{it.value}</option>
    });
  }

  renderPayForOrderModal = () => {
    let submitButton = <Button style = {{float:"right"}} variant="secondary" type="submit">Sevkiyat Oluştur</Button>;
    let {orderId} = this.state;

    const payTypeOptions = payTypes;
    const reasonOptions = reasons;


    let payTypeOptionsDOM = this.renderDropdownOptions(payTypeOptions);
    let reasonOptionsDOM = this.renderDropdownOptions(reasonOptions);

    return <Modal autoFocus={true} show={this.state.showPayForOrderModal} onHide={() => this.onModalClose()} dialogClassName="modal-90w">
            <Modal.Header closeButton>
              <Modal.Title>Ödeme Bilgisi Girişi</Modal.Title>
            </Modal.Header>
  
            <Modal.Body>
              <div className="centered-80-percent margin-left-right-40">
                <Form onSubmit={this.onSubmit}>
                  <Form.Group className="mb-4" controlId="formPayType">
                    <Form.Label>Ödeme Tipi</Form.Label>
                    <Form.Select name="payType">
                    <option>Seçiniz</option>
                    {payTypeOptionsDOM}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formReason">
                    <Form.Label>Ödeme Tipi</Form.Label>
                    <Form.Select name="reason">
                    <option>Seçiniz</option>
                    {reasonOptionsDOM}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formAmount">
                    <Form.Label>Ödeme Miktarı</Form.Label>
                    <Form.Control name="amount" type="number" placeholder="Ödeme Miktarı"/>
                  </Form.Group>
                  {submitButton} 
                </Form>
                </div>
            </Modal.Body>
          </Modal>
  };

  render() {
  return (
    <AuthorizedPage role={Role.FINANCE_ADMIN}>
      {this.renderPayForOrderModal()}
      <div className="row" style={{marginTop:20}}>
            <div className="col-2">
              <div className="basket-border" style={{padding:15}}>
                <p>Bakiye</p>
                <p>{this.state.accountingSummary.remainingAmountToPurchase} &#8378;</p>
                </div>
            </div>
            <div className="col-2">
              <div className="basket-border" style={{padding:15}}>
                <p>Sipariş Adedi</p>
                <p>{this.state.accountingSummary.totalOrderCount}</p>
              </div>
            </div>
            <div className="col-2">
              <div className="basket-border" style={{padding:15}}>
                <p>Siparişler Tutarı</p>
                <p>{this.state.accountingSummary.totalAmountOfOrders} &#8378;</p>
              </div>
            </div>
            <div className="col-2">
              <div className="basket-border" style={{padding:15}}>
                <p>Ödenmiş Tutar</p>
                <p>{this.state.accountingSummary.totalAmountOfOrderPayments} &#8378;</p>
              </div>
            </div>
            <div className="col-3">
              <div className="basket-border" style={{padding:15}}>
                <p>Ürün İadesi Ödemesi</p>
                <p>{this.state.accountingSummary.totalAmountOfProductRefunds} &#8378;</p>
                </div>
            </div>
            <div className="col-1">
              <div className="basket-border" style={{padding:15}}>
                <p>TBD</p>
                <p>{this.state.accountingSummary.totalAmountOfProductRefunds} &#8378;</p>
                </div>
            </div>
           
      </div>
      <div className="centered-98-percent" style={{marginTop:50}}>
          <div className="row">
            {this.renderAccountingTransactions()}
          </div>
      </div>
    </AuthorizedPage>
    )
  }
}

export default BuyerFinanceManagement;